;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { LucideIcon } from "lucide-react";
import {
	Activity,
	Banknote,
	BanknoteArrowUp,
	Brain,
	Building2,
	ClipboardCheck,
	HandCoins,
	Home,
	Key,
	PhoneCall,
	PieChart,
	Receipt,
	Star,
	Target,
	TrendingUp,
	UserStar,
	Users,
	Wallet,
	Workflow,
	Wrench,
} from "lucide-react";

export const getViewIcon = (viewName: string): LucideIcon => {
	const normalizedName = viewName.toLowerCase();

	switch (normalizedName) {
		case "leasing":
			return Home;
		case "properties":
			return Key;
		case "prospects":
			return Users;
		case "tenants":
			return Target;
		case "receivables":
		case "payments":
			return Wallet;
		case "work orders":
			return Wrench;
		case "maintenance":
			return ClipboardCheck;
		case "investors":
			return TrendingUp;
		case "financials":
		case "financial":
		case "financial statements":
			return Banknote;
		case "financial performance":
			return TrendingUp;
		case "accounts payable":
			return HandCoins;
		case "accounts receivable":
			return BanknoteArrowUp;
		case "organization":
		case "company":
			return Building2;
		case "users":
		case "team":
			return Users;
		case "billing":
		case "invoices":
			return Receipt;
		case "automations":
		case "workflows":
		case "workflow":
		case "processes":
			return Workflow;
		case "agents":
		case "ai":
		case "assistant":
			return Brain;
		case "reputation":
			return Star;
		case "leaderboard":
			return UserStar;
		case "reporting":
		case "user activity":
		case "user-activity":
			return Activity;
		case "tours":
		case "listings":
			return Key;
		case "communications":
		case "voip":
		case "voice":
		case "calls":
			return PhoneCall;
		default:
			return PieChart;
	}
};
